<template>
  <button
    class="flex w-full h-10 items-center gap-1.5 px-0.5 component-style hover:text-white cursor-pointer transition-all duration-200 hover:transform hover:scale-[1.02]"
    @click="toggleButton"
  >
    <div class="w-7 h-7 md:w-9 md:h-9">
      <slot name="img" />
    </div>
    <div class="text-left">
      <h3 class="font-verdana font-semibold text-xs">
        <slot name="title" />
      </h3>
      <p class="small-p text-gray-400">
        <slot name="subtitle" />
      </p>
    </div>
  </button>
</template>

<script>
export default {
  methods: {
    toggleButton() {
      this.$emit('toggle-button', this.buttonName) // Use 'toggle-button' event
    }
  },
  props: {
    buttonName: String
  }
}
</script>

<style scoped>
.component-style {
  border-radius: 4px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.component-style:hover {
  background: #2f71cd;
  transform: translateX(4px);
  box-shadow: 0 2px 8px rgba(47, 113, 205, 0.3);
}

.component-style:hover .small-p {
  color: white;
}

.component-style:active {
  transform: translateX(2px) scale(0.98);
}
</style>
